export default __webpack_public_path__ + "static/media/IntegrationDataGps.7098028e.pdf";